import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import myStyles from "./Style";

export default function Welcome(props) {
  const classes = myStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  const handleClick = e => {
    props.history.push(`/${e.currentTarget.id}`);
  };
  return (
    <Box
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      component="main"
      padding={matches ? "70px 5px" : "70px 30px"}
    >
      <AppBar>
        <Toolbar>
          <Typography variant={matches ? "h6" : "h4"} className={classes.title}>
            Yow!
          </Typography>

          <Button
            id="login"
            onClick={handleClick}
            size={matches ? "small" : "medium"}
            className={classes.button}
            color="inherit"
            variant="outlined"
          >
            Log In
          </Button>
          <Button
            id="signup"
            onClick={handleClick}
            size={matches ? "small" : "medium"}
            color="inherit"
            variant="outlined"
          >
            Sign Up
          </Button>
        </Toolbar>
      </AppBar>

      <Typography className={classes.welcome} variant="h3">
        Welcome!
      </Typography>
      <Typography
        className={classes.intro}
        align="center"
        variant={matches ? "h6" : "h5"}
      >
        <strong>Yow</strong> is a simple chat web app that provides basic chat
        functionality like private and group messaging, adding and blocking
        contacts, theme customization and more.
      </Typography>
      <Grid spacing={3} container alignItems="center" justify="center">
        <Grid item xs={12} sm={9}>
          <img
            src={require("../../assets/yow.PNG")}
            alt=""
            className={classes.img}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography
            className={classes.typo}
            align="center"
            variant={matches ? "h6" : "h5"}
          >
            Modern user interface
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box
            width="70%"
            height="3px"
            borderRadius="3px"
            bgcolor="primary.main"
            margin="auto"
          ></Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <img
            className={classes.img}
            src={require("../../assets/profile.PNG")}
            alt=""
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            className={classes.typo}
            align="center"
            variant={matches ? "h6" : "h5"}
          >
            Use the profile settings to change your picture, username, password
            or delete your account
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box
            width="70%"
            height="3px"
            borderRadius="3px"
            bgcolor="primary.main"
            margin="auto"
          ></Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <img
            className={classes.img}
            src={require("../../assets/group.PNG")}
            alt=""
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            className={classes.typo}
            align="center"
            variant={matches ? "h6" : "h5"}
          >
            Use the group settings to change group profile picture and name.
            Exit or delete group. View group members.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box
            width="70%"
            height="3px"
            borderRadius="3px"
            bgcolor="primary.main"
            margin="auto"
          ></Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <img
            className={classes.img}
            src={require("../../assets/settings.PNG")}
            alt=""
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            className={classes.typo}
            align="center"
            variant={matches ? "h6" : "h5"}
          >
            Change the look and feel of the app. Customize colors and themes
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
